export const API_RESPONSE_TYPE = Object.freeze({
  BLOB: "blob",
  ARRAY_BUFFER: "arraybuffer",
});
